// Sonido de comanda nueva — Web Audio API, sin assets externos.
// Los browsers bloquean audio sin interacción previa: AudioContext se crea y
// reanuda en el primer gesto del usuario (ver unlockAudio).

let ctx: AudioContext | null = null

function getContext(): AudioContext | null {
  if (typeof window === 'undefined') return null
  if (!ctx) {
    const AC = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
    if (!AC) return null
    ctx = new AC()
  }
  return ctx
}

/** Llamar en el primer pointerdown/click del usuario para desbloquear audio. */
export function unlockAudio() {
  const c = getContext()
  if (c && c.state === 'suspended') {
    c.resume().catch(() => {})
  }
}

/** Chime corto de 3 notas ascendentes (E5 → G#5 → B5), ~0.7s. */
export function playChime() {
  if (isSoundMuted()) return
  const c = getContext()
  if (!c) return
  if (c.state === 'suspended') {
    c.resume().catch(() => {})
  }
  const now = c.currentTime
  const notes = [659.25, 830.61, 987.77]
  notes.forEach((freq, i) => {
    const osc = c.createOscillator()
    const gain = c.createGain()
    osc.type = 'sine'
    osc.frequency.value = freq
    const t = now + i * 0.15
    gain.gain.setValueAtTime(0.0001, t)
    gain.gain.exponentialRampToValueAtTime(0.25, t + 0.02)
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.18)
    osc.connect(gain)
    gain.connect(c.destination)
    osc.start(t)
    osc.stop(t + 0.2)
  })
}

const MUTE_KEY = 'esmipos:sound_muted'

export function isSoundMuted(): boolean {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(MUTE_KEY) === '1'
}

export function setSoundMuted(muted: boolean) {
  window.localStorage.setItem(MUTE_KEY, muted ? '1' : '0')
}
